import {extend, TempusDominus} from "@eonasdan/tempus-dominus";
import {biOneIcons, load} from '@eonasdan/tempus-dominus/dist/plugins/bi-one'
// import moment_parse from '@eonasdan/tempus-dominus/dist/plugins/moment-parse'

extend(load);
// extend(moment_parse);

$(document).ready(function() {

  $('.datetimepicker').each((ix, el) => {
    // const datepicker = new Datepicker(el, {
    let elOptions = JSON.parse($("input", el).attr("data-date-options"));
    const datepicker = new TempusDominus(el, {
      display: {
        icons: biOneIcons
      },
      localization: {
        locale: elOptions.locale,
        dateFormats: {
          LL: elOptions.format
        },
        format: "LL",
        hourCycle: "h23",
        toggleMeridiem: "",
        startOfTheWeek: 1
      }
    });
  });

  $('.datetimerange').each(function(){
    var $this = $(this)
    var range1 = $($this.find('.input-group')[0])
    var range2 = $($this.find('.input-group')[1])

    if(range1.data("DateTimePicker").date() != null)
      range2.data("DateTimePicker").minDate(range1.data("DateTimePicker").date());

    if(range2.data("DateTimePicker").date() != null)
      range1.data("DateTimePicker").maxDate(range2.data("DateTimePicker").date());

    range1.on("dp.change",function (e) {
      if(e.date)
        range2.data("DateTimePicker").minDate(e.date);
      else
        range2.data("DateTimePicker").minDate(false);
    });

    range2.on("dp.change",function (e) {
      if(e.date)
        range1.data("DateTimePicker").maxDate(e.date);
      else
        range1.data("DateTimePicker").maxDate(false);
    });
  });

});
